
// components/BrandPhoneMockups.js
export const BrandPhoneMockups = () => {
    return (
        <div className="flex-1 relative">
            <div className="absolute top-1/2 left-1/2 w-72 h-72 bg-blue-200/30 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2"></div>
            <div className="absolute top-1/2 left-1/2 w-72 h-72 bg-purple-200/30 rounded-full blur-3xl -translate-x-full -translate-y-1/2"></div>
            <div className="relative flex gap-4">
                <PhoneTemplate
                    rotation="-rotate-6"
                    translation="translate-y-8"
                    gradient="from-purple-500 to-pink-500"
                />
                <PhoneTemplate
                    rotation="rotate-6"
                    translation="-translate-y-8"
                    gradient="from-blue-500 to-purple-500"
                />
            </div>
        </div>
    )
}



const PhoneTemplate = ({ rotation, translation, gradient }) => {
    return (
        <div className={`w-[240px] transform ${rotation} ${translation}`}>
            <div className="bg-black rounded-[2rem] p-3">
                <div className={`bg-gradient-to-br ${gradient} rounded-[1.7rem] aspect-[9/19.5]`}></div>
            </div>
        </div>
    )
}